"use strict";
import { Format } from '@ark-ui/react/format';

const FormatNumber = Format.Number;
const FormatByte = Format.Byte;

export { FormatByte, FormatNumber };
